<template>
  <dx-cell style="width:10px" v-bind="$attrs" v-on="$listeners" :class="this.$attrs.column.className ? this.$attrs.column.className($attrs.tableRow.row) : ''">
    <router-link tag="a" :to="toUrl" class="edit-link" v-b-tooltip.hover.d150 :title="tooltipTitle">
      <template v-if="this.$attrs.column.name == 'EDIT' || this.$attrs.column.name == 'COPY'">
        <i v-if="this.$attrs.column.name == 'EDIT'" class="fa fa-pencil-alt"></i>
        <i v-if="this.$attrs.column.name == 'COPY'" class="fa fa-copy"></i>
      </template>
      <template v-else>{{ value }}</template>
    </router-link>
  </dx-cell>
</template>

<script>
import { DxGrid, DxTable } from "@devexpress/dx-vue-grid-bootstrap4";
import Cell from "./Cell";

export default {
  inheritAttrs: false,
  props: ["value"],
  components: {
    DxCell: DxTable.components.DxCell,
    DxTable
  },
  computed: {
    toUrl() {
      let result;
      let columnUrl;

      if (this.$attrs.column.url instanceof Function) {
        result = this.$attrs.column.url(this.$attrs.tableRow.row);
      }

      if (
        this.$attrs.column.url &&
        !(this.$attrs.column.url instanceof Function)
      ) {
        columnUrl = this.$attrs.column.url;
      } else {
        columnUrl = this.$route.name.toLowerCase();
      }

      result =
        result != null
          ? result
          : "/" + columnUrl + "/" + this.$attrs.tableRow.row.id;

      return result;
    },
    tooltipTitle() {
      return this.$attrs.column.tooltipTitle ? this.$attrs.column.tooltipTitle : this.$t('Открыть');
    }
  }
};
</script>

